import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import { AuthModalState } from "@/@types/general";
import { authAxios } from "@/api/axios.ts";
import { ROUTES } from "@/config/routes.ts";

import useModalRouter from "../useModalRouter";

interface Response {
  data: {
    token: string;
    is_active: boolean;
  };
}

export const useCheckCode = (code: number | null): { token: string | null } => {
  const navigate = useNavigate();
  const [token, setToken] = useState<string | null>(null);
  const { openModal } = useModalRouter();

  useEffect(() => {
    if (code) {
      const formData = new FormData();
      formData.append("code", code.toString());

      const intervalId = setInterval(async () => {
        try {
          const response = await authAxios.post<Response>("/user/code-login-check", formData).then((res) => res.data);
          clearInterval(intervalId);
          const token = response.data.token;
          if (response.data.is_active) {
            const { setToken } = await import("@/api/tokens.ts");
            setToken(token);
            navigate(ROUTES.GATE.PROFILES);
          } else {
            setToken(token);
            openModal([MODAL_ROUTES.AUTH, MODAL_ROUTES.AUTH_SESSIONS], { token: response.data.token });
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error: any) {
          if (!error.response.data.data) {
            clearInterval(intervalId);
            navigate(`?auth=${AuthModalState.Login}`);
          }
        }
      }, 3000);

      return () => clearInterval(intervalId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return { token };
};
